import { Cns, Cpf } from 'components/label'
import React, { Fragment } from 'react'

interface CpfOrCnsProps {
  readonly cpf?: string
  readonly cns?: string
  readonly defaultText?: string
}

export function CpfOrCns({ cpf, cns, defaultText = '-' }: CpfOrCnsProps) {
  if (cpf) return <Cpf value={cpf} />
  if (cns) return <Cns value={cns} />

  return <Fragment>{defaultText}</Fragment>
}
